export default __webpack_public_path__ + "static/media/front-end.1cb6ef3f.png";